import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Input } from 'src/components/ui/input';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from 'src/components/ui/select';
import { ConfigurationCriteriaEnum } from 'src/features/configuration/configurationCriteria/enums/ConfigurationCriteriaEnum';
import { useConfigurationCriterion } from 'src/features/configuration/configurationCriteria/hooks/useConfigurationCriterion';
import { OpenSessionCriterion } from 'src/services/api/getOpenSessionCriteria';

export const ConfigurationCriterionChildrenConfig = (
  criterion: OpenSessionCriterion,
) => {
  const { t } = useTranslation('configuration');
  const { handleUpdateCriteria } = useConfigurationCriterion(criterion);
  const [value3, setValue3] = useState(criterion.values?.value3);
  const [value1, setValue1] = useState(criterion.values?.value1);
  const [value2, setValue2] = useState(criterion.values?.value2);

  useEffect(() => {
    setValue3(criterion.values?.value3);
  }, [criterion.values?.value3]);
  useEffect(() => {
    setValue1(criterion.values?.value1);
  }, [criterion.values?.value1]);
  useEffect(() => {
    setValue2(criterion.values?.value2);
  }, [criterion.values?.value2]);

  return {
    [ConfigurationCriteriaEnum.ForecastNotValidatedSince]: (
      <>
        <span>{t('The forecast has not been validated since')}</span>
        <Input
          className='size-8 p-1 text-center'
          disabled={!criterion.apply}
          value={value1}
          onChange={(e) => {
            setValue1(e.target.value);
            handleUpdateCriteria('value1', e.target.value, true);
          }}
        />
        <span>{t('months')}</span>
      </>
    ),
    [ConfigurationCriteriaEnum.SalesDeviationForecast]: (
      <>
        <span>{t('The number of sales has a deviation greater than')}</span>
        <Input
          className='size-8 p-1 text-center'
          disabled={!criterion.apply}
          value={value1}
          onChange={(e) => {
            setValue1(e.target.value);
            handleUpdateCriteria('value1', e.target.value, true);
          }}
        />
        <span>{t('sales compared to forecast data for the last month')}</span>
      </>
    ),
    [ConfigurationCriteriaEnum.SmapeLastMonths]: (
      <>
        <span>{t('The SMAP of the last')}</span>
        <Input
          className='size-8 p-1 text-center'
          disabled={!criterion.apply}
          value={value1}
          onChange={(e) => {
            setValue1(e.target.value);
            handleUpdateCriteria('value1', e.target.value, true);
          }}
        />
        <span>{t('months is')}</span>
        <Select
          value={`${value2}`}
          onValueChange={(value) =>
            handleUpdateCriteria('value2', value, false)
          }
        >
          <SelectTrigger disabled={!criterion.apply} className='h-8 w-48'>
            <SelectValue placeholder='' />
          </SelectTrigger>
          <SelectContent>
            <SelectItem disabled={!criterion.apply} value='gt'>
              {t('Greater than')}
            </SelectItem>
            <SelectItem disabled={!criterion.apply} value='lt'>
              {t('Less than')}
            </SelectItem>
            <SelectItem disabled={!criterion.apply} value='ge'>
              {t('Greater than or equal to')}
            </SelectItem>
            <SelectItem disabled={!criterion.apply} value='le'>
              {t('Less than or equal to')}
            </SelectItem>
          </SelectContent>
        </Select>
        <Input
          className='size-8 p-1 text-center'
          disabled={!criterion.apply}
          value={value3}
          onChange={(e) => {
            setValue3(e.target.value);
            handleUpdateCriteria('value3', e.target.value, true);
          }}
        />
      </>
    ),
    [ConfigurationCriteriaEnum.FirstStockingLastMonths]: (
      <>
        <span>{t('Date of first stocking in the last')}</span>
        <Input
          className='size-8 p-1 text-center'
          disabled={!criterion.apply}
          value={value1}
          onChange={(e) => {
            setValue1(e.target.value);
            handleUpdateCriteria('value1', e.target.value, true);
          }}
        />
        <span>{t('last months')}</span>
      </>
    ),
    [ConfigurationCriteriaEnum.TrackingSignal]: (
      <>
        <span>{t('Tracking signal is equal to -3 or 3 in the last')}</span>
        <Input
          className='size-8 p-1 text-center'
          disabled={!criterion.apply}
          value={value1}
          onChange={(e) => {
            setValue1(e.target.value);
            handleUpdateCriteria('value1', e.target.value, true);
          }}
        />
        <span>{t('last months')}</span>
      </>
    ),
    [ConfigurationCriteriaEnum.DestockingLastDays]: (
      <>
        <span>{t('Destocking references not stopped since less than')}</span>
        <Input
          className='size-8 p-1 text-center'
          disabled={!criterion.apply}
          value={value1}
          onChange={(e) => {
            setValue1(e.target.value);
            handleUpdateCriteria('value1', e.target.value, true);
          }}
        />
        <span>{t('days')}</span>
      </>
    ),
  };
};
